export const faqItems = [
  {
    question: '快猫平台是免费使用的吗？',
    answer: '是的，快猫平台的基础功能对所有用户完全免费。你可以免费注册账号、发布视频、浏览内容和与其他用户互动。部分高级功能如创作者数据分析、AI创作助手高级版等需要达到一定条件后解锁，但不影响基础创作体验。',
  },
  {
    question: '如何在快猫上开始创作第一条视频？',
    answer: '下载快猫应用并注册账号后，点击底部"+"按钮即可进入创作界面。你可以选择直接拍摄视频，或从相册导入已有的视频素材。快猫内置了丰富的编辑工具，包括剪辑、配乐、滤镜、字幕和特效等。完成编辑后，添加标题和话题标签即可发布。我们还准备了详细的新手教程，在"创作学院"中查看。',
  },
  {
    question: '快猫创作者激励计划需要满足什么条件？',
    answer: '快猫创作者激励计划面向所有持续发布原创内容的创作者开放。基础参与条件包括：账号注册满30天、累计发布原创视频不少于20条、账号信用分在90分以上。满足条件后，你可以在"创作者中心"申请加入激励计划。平台会根据内容质量和数据表现提供流量分成、创作基金和品牌合作机会。',
  },
  {
    question: '快猫平台如何保障创作者的内容版权？',
    answer: '快猫建立了完善的内容版权保护体系。每条原创视频发布时，平台会自动生成数字指纹并记录确权信息。如果发现他人搬运你的内容，可以通过"版权保护中心"一键发起维权。平台还提供原创认证标识，帮助用户辨识原创内容。此外，快猫与多家版权机构合作，为创作者提供专业的法律支持。',
  },
  {
    question: '在快猫上发布内容需要注意哪些规范？',
    answer: '快猫严格遵循国家法律法规和社区规范。发布内容时需要注意：禁止发布色情低俗、暴力血腥、违法犯罪相关内容；禁止传播虚假信息和谣言；禁止侵犯他人隐私和知识产权；禁止发布垃圾广告和恶意营销内容。建议创作者仔细阅读《快猫社区规范》和《内容审核标准》，确保内容合规。违规内容将面临下架、账号限制甚至封禁处理。',
  },
  {
    question: '快猫的青少年模式有哪些保护措施？',
    answer: '快猫高度重视未成年人保护。青少年模式下：每日使用时长限制为40分钟；每日22:00至次日6:00无法使用；无法进行直播、打赏和购买操作；仅展示经过筛选的适合青少年的内容。我们采用人脸识别技术防止未成年人冒用成年人账号，并持续优化内容筛选机制，为青少年营造健康安全的网络环境。',
  },
  {
    question: '快猫的推荐算法是如何运作的？',
    answer: '快猫的推荐算法基于多个维度综合评估：内容质量（清晰度、完播率、互动数据）、用户兴趣（浏览历史、互动偏好）、创作者信用（账号信用分、历史内容表现）以及时效性因素（新发布内容获得初始曝光）。算法会优先推荐高质量、与用户兴趣匹配的内容。对于新创作者，平台提供专门的流量扶持计划，帮助优质新人获得曝光机会。',
  },
];